import { useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { API_URL } from '../config/api';


import Sidebar from './Sidebar';
import ProductsView from '../pages/ProductsView';
import PartnersView from '../pages/PartnersView';
import StoragesView from '../pages/StoragesView';
import FinanceView from '../pages/FinanceView';
import StaffView from '../pages/SaffView';
import SalesMode from '../pages/SalesMode';
import WarehouseModal from '../pages/tables/customComponentsTable/WarehouseModal';
import AnalyticsView from '../pages/AnalyticsView';
import RealizationView from '../pages/RealizationView';
import ReportsView from '../pages/ReportsView';
import TaxesView from '../pages/TaxesView';
import AccountView from '../pages/AccountView';
import DocumentsView from '../pages/DocumentsView';
import GreenMagProView from '../pages/GreenMagProView';
import GreenMagCashbackView from '../pages/GreenMagCashbackView';
import PaymentMethods from '../pages/PaymentMethods';

import styles from '../styles/mainPage.module.css';

const MainPage = ({ user, company, onLogout }) => {
  const [selectedView, setSelectedView] = useState('analytics');
  const [showMenuTwo, setShowMenuTwo] = useState(false);
  const [warehouseModalOpen, setWarehouseModalOpen] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('accessToken') || Cookies.get('accessToken');

      if (token) {
        await axios.post(
          `${API_URL}/api/account/logout`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
    } catch (error) {
      console.error('Ошибка при logout:', error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      Cookies.remove('accessToken');
      Cookies.remove('refreshToken');

      onLogout();
    }
  };

  return (
    <div className={styles.container}>

      <Sidebar
        user={user}
        selected={selectedView}
        onSelect={(view) => {
          if (view === 'sales') {
            setWarehouseModalOpen(true);
          } else {
            setSelectedView(view);

            if (
              view === 'account' ||
              view === 'storages' ||
              view === 'finance' ||
              view === 'paymentMethods' ||
              view === 'staff'
            ) {
              setShowMenuTwo(true);
            } else {
              setShowMenuTwo(false);
            }
          }
        }}
        showMenuTwo={showMenuTwo}
        setShowMenuTwo={setShowMenuTwo}
        onLogout={handleLogout}
      />

      {selectedView === 'products' && (
        <ProductsView showMenuTwo={showMenuTwo} setShowMenuTwo={setShowMenuTwo} />
      )}
      {selectedView === 'partners' && <PartnersView />}
      {selectedView === 'account' && <AccountView />}
      {selectedView === 'storages' && <StoragesView />}
      {selectedView === 'finance' && <FinanceView />}
      {selectedView === 'paymentMethods' && <PaymentMethods />}
      {selectedView === 'analytics' && <AnalyticsView />}
      {selectedView === 'realization' && <RealizationView />}
      {selectedView === 'reports' && <ReportsView />}
      {selectedView === 'taxes' && <TaxesView />}
      {selectedView === 'staff' && <StaffView />}
      {selectedView === 'documents' && <DocumentsView />}
      {selectedView === 'greenmagPro' && <GreenMagProView />}
      {selectedView === 'greenmagCashback' && <GreenMagCashbackView />}

      <WarehouseModal
        isOpen={warehouseModalOpen}
        onClose={() => setWarehouseModalOpen(false)}
        onSelect={(warehouse) => {
          setSelectedWarehouse(warehouse);
          setSelectedView('sales');
        }}
      />

      {selectedView === 'sales' && selectedWarehouse && (
        <SalesMode
          warehouse={selectedWarehouse}
          seller=""
          onClose={() => setSelectedView('products')}
        />
      )}
    </div>
  );
};

export default MainPage;
